import { FC } from 'react'

import { Card, Stack } from '@forto-dev/phoenix-ui-core'

import { AddressDetail } from './components/AddressDetail'
import { AddressSearch } from './components/AddressSearch'
import { ManualAddress } from './components/ManualAddress'
import {
  AddressSelectorContextProvider,
  AddressSelectorContextProviderProps,
} from './contexts/AddressSelectorContextProvider'
import { useAddressSelectorContext } from './contexts/useAddressSelectorContext'

export const AddressSelectorInner: FC = () => {
  const { manualMode } = useAddressSelectorContext()

  return (
    <Card variant="muted">
      <Stack gap={16}>
        <AddressSearch />
        {manualMode ? <ManualAddress /> : <AddressDetail />}
      </Stack>
    </Card>
  )
}

export type AddressSelectorProps = AddressSelectorContextProviderProps

export const AddressSelector: FC<AddressSelectorProps> = (props) => {
  return (
    <AddressSelectorContextProvider {...props}>
      <AddressSelectorInner />
    </AddressSelectorContextProvider>
  )
}
